import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const OrderDefaultProps = {
  ...BaseDefaultProps,
  date: null,
  delivered: false,
  deliveryNotes: [],
  hasInvoice: false,
  isShippingAvailable: false,
  origin: null,
  reference: null,
  shippingType: {},
  status: null,
  totalDelivered: null,
  totalLeft: null,
  totalRaw: null,
  updated: null,
  worksite: null,
};

export const OrderPropTypes = {
  ...BasePropTypes,
  date: PropTypes.string,
  delivered: PropTypes.bool,
  deliveryNotes: PropTypes.arrayOf(PropTypes.number),
  hasInvoice: PropTypes.bool,
  id: PropTypes.number.isRequired,
  isShippingAvailable: PropTypes.bool,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  origin: PropTypes.string,
  reference: PropTypes.string,
  shippingType: PropTypes.shape({
    id: PropTypes.string,
  }),
  status: PropTypes.shape({
    code: PropTypes.string,
    label: PropTypes.string,
  }),
  totalDelivered: PropTypes.number,
  totalLeft: PropTypes.number,
  totalRaw: PropTypes.number,
  updated: PropTypes.number,
  worksite: PropTypes.string,
};
